var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94 0C12.3248 0 15.88 3.55517 15.88 7.94C15.88 12.3248 12.3248 15.88 7.94 15.88C3.55517 15.88 0 12.3248 0 7.94C0 3.55517 3.55517 0 7.94 0ZM6.83895 3.94415H7.80948C7.98652 3.94415 8.13256 4.09019 8.13256 4.26723V8.0072H11.5456C11.7239 8.0072 11.8686 8.15323 11.8686 8.33028V9.30081C11.8686 9.47915 11.7226 9.62389 11.5456 9.62389H6.51457V4.26723C6.51457 4.08889 6.66061 3.94415 6.83895 3.94415ZM7.94 1.80278C11.3298 1.80278 14.0772 4.55025 14.0772 7.94C14.0772 11.3298 11.3298 14.0772 7.94 14.0772C4.55025 14.0772 1.80278 11.3298 1.80278 7.94C1.80278 4.55154 4.55025 1.80278 7.94 1.80278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.88,
    height: 15.88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.4d4b62741712135a8213be90f2dbd8d6.svg";
export { ForwardRef as ReactComponent };